import { ChangeDetectorRef, Component, inject, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AccordionComponent } from '../../../shared/components/accordion/accordion.component';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { NgZorroModule } from '../../../shared/modules/ng-zorro/ng-zorro.module';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { STATIC_DATA } from '../../../shared/constants/static-data.constants';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { TableRowActionsModel } from '../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../shared/interfaces/actions';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators
} from '@angular/forms';
import { DatePipe } from '@angular/common';
import { LeadDetailsService } from '../../../services/lead-details.service';
import { Program } from '../../../interfaces/user.interface';
import { BaseComponent } from '../../../shared/utils/base.component';
import { PopupDialogComponent } from '../../../shared/components/popup-dialog/popup-dialog.component';
import { AdditionalAttribute, AdditionalAttributeResponse } from '../../../interfaces/additional-attribute.model';
import { FacilityStay, FacilityStayGridData } from '../../../interfaces/facility-stay.model';
import { GridAction, AdditionalAttributeGridData } from '../../../shared/components/list-table/grid-action.model';
import { NzAriaLabelDirective } from '../../../shared/directives/nz-aria-label.directive';
import { AuthorizationUtility } from '../../../shared/authorization/auth.utility';
import { MEMBER_VIEW_PAGE_IDS, TABS } from '../../../shared/constants/page.constants';
import { differenceInCalendarDays } from 'date-fns';
import { UserService } from '../../../services/user.service';
import { DatePickerComponent } from '../../../shared/components/date-picker/date-picker.component';
import { DropdownSelectComponent } from '../../../shared/components/dropdown-select/dropdown-select.component';
import { DialogConfig, DialogService } from '../../../shared/services/dialog.service';
import { AuthorizeDirective } from '../../../shared/authorization/authorize.directive.';

enum Mode {
  Read = 'read',
  Edit = 'edit'
}
@Component({
  selector: 'ppl-additional-attributes',
  standalone: true,
  imports: [
    AccordionComponent,
    ListTableComponent,
    NgZorroModule,
    ButtonComponent,
    ReactiveFormsModule,
    FormsModule,
    NzDatePickerModule,
    PopupDialogComponent,
    NzAriaLabelDirective,
    DatePickerComponent,
    DropdownSelectComponent,
    AuthorizeDirective
  ],
  templateUrl: './additional-attributes.component.html',
  styleUrl: './additional-attributes.component.css',
})
export class AdditionalAttributesComponent extends BaseComponent implements OnInit {
  @ViewChild('fsHistoryDialog') fsHistoryDialogRef!: TemplateRef<any>;
  private dialogSvc = inject(DialogService);
  //attributeForm: any;
  selectedAttributeType!: string;
  attributeValue!: Date | string;
  startDate!: Date | string;
  endDate!: Date | string;
  mode: Mode = Mode.Read;

  responseData!: AdditionalAttribute[];
  tabId = TABS.AdditionalAttributes;

  actionButtons: TableRowActionsModel = new TableRowActions();
  gridData: AdditionalAttributeGridData[] = [];
  showConfirmationDialog = false;
  disabledDate!: (current: Date) => boolean;
  pageId = MEMBER_VIEW_PAGE_IDS[this.userService.getFirstSegment()!];


  // manually override the component to make it readonly
  @Input() readonly = false;
  
  cols = [
    {
      field: 'attribute_text',
      header: 'Field Name',
      jsonpath: 'attribute_text',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'value',
      header: 'Field Value',
      jsonpath: 'value',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'effective_from_date',
      header: 'Effective From Date',
      jsonpath: 'effective_from_date',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
    {
      field: 'effective_to_date',
      header: 'Effective To Date',
      jsonpath: 'effective_to_date',
      isDisplayedAtHeader: 'y',
      isSearchable: 'n',
    },
  ];
  index!: number;
  displayTypeError = false;
  displayValueError = false;
  id !: number;
  entry !: string;
  program ?: Program;
  options: any[] = [];
  displayDates = false;
  lookupData: Record<string, AdditionalAttribute['lookup']> = {};
  fieldType = '';
  dataType = '';
  selectedAttribute!: string;
  displayStartDateError !: boolean;
  displayEndDateError!: boolean;
  attributeId!: string | null;
  additionalAttribute!: AdditionalAttributeGridData | null;
  enrollment_id!: number;
  isSectionEditable: boolean = false;
  canEditEntry = false;
  canAddEditFs = false;
  canDeleteFs = false;
  maxDateForCalendar: any;

  isPplAdmin = false;

  // Facility Stay section
  fsMode: 'read' | 'add' | 'edit' = 'read';
  facilityStayData: FacilityStayGridData[] = [];
  selectedFacilityStay: FacilityStayGridData | null = null;
  facilityStayForm!: FormGroup;
  fsValidationErrors: Record<string, string> = {};
  showFsDeleteDialog = false;
  fsHistoryData: any[] = [];
  fsHistoryCols = [
    { field: 'source', header: 'Original Source' },
    { field: 'admitDate', header: 'Start Date' },
    { field: 'dischargeDate', header: 'End Date' },
    { field: 'modifiedByName', header: 'Modified By' },
    { field: 'modifiedDate', header: 'Modified Date' },
    { field: 'facilityName', header: 'Facility Name' },
    { field: 'isActiveDisplay', header: 'Is Active' },
    { field: 'createdDateDisplay', header: 'Created Date' },
    { field: 'createdByNameDisplay', header: 'Created By' },
    { field: 'eventType', header: 'Event Type' },
    { field: 'lastEventTs', header: 'Event Date' },
    { field: 'stayStatus', header: 'Stay Status' },
    { field: 'encounterId', header: 'Encounter Id' },
  ];

  fsEventTypeOptions: { label: string; value: string }[] = [];
  fsCancelledOptions = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
  ];

  fsCols = [
    { field: 'source', header: 'Original Source', jsonpath: 'source', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'admitDate', header: 'Start Date', jsonpath: 'startDate', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'dischargeDate', header: 'End Date', jsonpath: 'endDate', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'modifiedByName', header: 'Last Modified By', jsonpath: 'lastModifiedBy', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'modifiedDate', header: 'Last Modified Date', jsonpath: 'lastModifiedDate', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'facilityName', header: 'Facility Name', jsonpath: 'facilityName', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'createdDateDisplay', header: 'Created Date', jsonpath: 'createdDateDisplay', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'createdByNameDisplay', header: 'Created By', jsonpath: 'createdByNameDisplay', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'eventType', header: 'Event Type', jsonpath: 'eventType', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'lastEventTs', header: 'Event Date', jsonpath: 'lastEventTs', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'stayStatus', header: 'Stay Status', jsonpath: 'stayStatus', isDisplayedAtHeader: 'y', isSearchable: 'n' },
    { field: 'encounterId', header: 'Encounter Id', jsonpath: 'encounterId', isDisplayedAtHeader: 'y', isSearchable: 'n' },
  ];

  constructor(
    private leadDetailService: LeadDetailsService,
    private cd: ChangeDetectorRef,
    private datePipe: DatePipe,
    private authUtility: AuthorizationUtility,
    private userService: UserService,
    private fb: FormBuilder,
  ) {
    super();
  }

  ngOnInit(): void {
    this.isSectionEditable = this.readonly ? false : this.authUtility.isSectionEditable(this.pageId, this.tabId, 'AdditionalAttributes');
    this.canEditEntry = this.authUtility.isSectionEditable(this.pageId, this.tabId, 'Edit_Attributes');
    this.canAddEditFs = this.authUtility.isSectionEditable(this.pageId, this.tabId, 'Edit_FacilityStay');
    this.canDeleteFs = this.authUtility.isSectionDeletable(this.pageId, this.tabId, 'Delete_FacilityStay');
    this.program = this.userService.getSelectedProgram();
    this.isPplAdmin = this.userService.isSelectedRole('PPL Admin');
    this.entry = this.userService.getLeadEntry() ?? '';

    this.enrollment_id = JSON.parse(this.userService.getSelectedLead()!);
    this.disabledDate = (current: Date): boolean => {
      if (this.selectedAttribute === 'Date of Death') {
        return differenceInCalendarDays(current, new Date()) > 0;
      }
      return false;
    };
    this.facilityStayForm = this.fb.group({
      startDate: [null as Date | null, Validators.required],
      endDate: [null as Date | null],
      facilityName: [null as string | null],
      eventType: [null as string | null],
    });
    this.fsEventTypeOptions = [
      { label: 'A01', value: 'A01' },
      { label: 'A03', value: 'A03' },
      { label: 'A11', value: 'A11' },
      { label: 'A13', value: 'A13' },
    ];

    this.getAdditionalAttributes(false);
    this.getFacilityStays();
  }

  updateMaxDate(): void {
    if (this.selectedAttribute === 'Date of Death') {
      const today = new Date();
      const yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      this.maxDateForCalendar = yesterday;
    } else {
      this.maxDateForCalendar = null;
    }
  }

  addAttributes() {

    const isEmpty = (value: string | Date) => !value || value === "";

    this.displayTypeError = isEmpty(this.selectedAttributeType);
    this.displayValueError = isEmpty(this.attributeValue);

    if (this.displayDates) {
      this.displayStartDateError = isEmpty(this.startDate);
      if (Number(this.attributeId) !== 154){
        this.displayEndDateError = isEmpty(this.endDate);
      }
    } else {
      this.displayStartDateError = false;
      this.displayEndDateError = false;
    }

    if ([this.displayEndDateError, this.displayStartDateError, this.displayValueError, this.displayTypeError].includes(true)) {
      return;
    }


    this.save();

  }


  validateSelectedAttribute(event: any) {
    console.log(event);

    this.initializeFormFields();

    // get the selected attribute details
    this.fieldType = event?.field_type as string;
    this.dataType = event?.data_type as string;
    this.displayDates = event?.show_date_range;
    this.selectedAttribute = event?.attribute_text;
    this.attributeId = event.id;
    this.updateMaxDate();
  }

  initializeFormFields(): void {
    //initialize attribute values
    this.attributeValue = '';
    this.startDate = '';
    this.endDate = '';

    // remove selected attributes error messages
    this.displayTypeError = false;
    this.displayValueError = false;
    this.displayStartDateError = false;
    this.displayEndDateError = false;
  }

  initializeSelectedAttribute() {
    this.fieldType = '';
    this.dataType = '';
    this.displayDates = false;
    this.selectedAttribute = '';
    this.attributeId = null;
  }

  validateAttributeValue(event: any) {
    this.displayValueError = false;
  }


  action(event: GridAction) {
    this.additionalAttribute = this.gridData.find((x: AdditionalAttributeGridData) => x.attribute_id == event.data?.attribute_id) ?? null;
    if (!this.additionalAttribute) return
    this.index = this.additionalAttribute.attribute_id;

    if (event && event.action === 'edit') {
      this.mode = Mode.Edit;
      this.validateSelectedAttribute(event.data);
      this.selectedAttributeType = this.additionalAttribute?.attribute_text;

      if (this.dataType === 'date') {
        this.attributeValue = new Date(this.additionalAttribute.value ?? '');
      } else {
        this.attributeValue = this.additionalAttribute.value ?? '';
      }


      if (this.additionalAttribute.show_date_range) {
        this.startDate = this.additionalAttribute.effective_from_date ? new Date(this.additionalAttribute.effective_from_date) : '';
        this.endDate = this.additionalAttribute.effective_to_date ? new Date(this.additionalAttribute.effective_to_date) : '';
      }

    }
    else if (event && event.action === 'delete') {
      this.showConfirmationDialog = true;
    }
  }

  cancelEdit() {
    this.mode = Mode.Read;
    this.selectedAttributeType = '';
    this.initializeFormFields();
    setTimeout(() => this.cd.detectChanges(), 1000);
  }


  save() {
    const payload = this.preparePayload();
    this.cd.detectChanges();

    this.leadDetailService.saveUpdateAttribute(payload, 'addAttr').subscribe(() => {
      this.getAdditionalAttributes(true);

      this.cancelEdit();
    })

  }

  handleConfirmDelete() {
    this.showConfirmationDialog = false;
    if (!this.additionalAttribute) return;
    this.deleteAdditionalAttributes(this.additionalAttribute.attribute_id)
  }


  deleteAdditionalAttributes(id: number) {
    this.leadDetailService.deleteAdditionalAttributes(this.program?.program_code ?? '', this.entry, id).subscribe(() => {
      this.getAdditionalAttributes(true);
      this.initializeSelectedAttribute();
    })
  }

  preparePayload() {
    const payload: any = {
      id: this.enrollment_id,
      enrollmentType: this.entry,
      programCode: this.program?.program_code,
      additional_attribute_id: this.attributeId,
      value: this.dataType === 'date'
        ? this.datePipe.transform(this.attributeValue, 'MM/dd/yyyy')
        : this.attributeValue
    }

    if (this.displayDates) {
      payload.effective_from_date = this.datePipe.transform(this.startDate, 'MM/dd/yyyy'); //super.formatDateString(this.startDate),
      payload.effective_to_date = this.datePipe.transform(this.endDate, 'MM/dd/yyyy'); //super.formatDateStringNoMs(this.endDate)
    } else {
      payload.effective_from_date = null;
      payload.effective_to_date = null;
    }

    if (this.mode === 'edit' && this.additionalAttribute) {
      payload.attribute_id = this.additionalAttribute.attribute_id;
    }

    return payload;
  }


  getAdditionalAttributes(isAfterUpdate: boolean) {
    this.leadDetailService.getAdditionalAttributes(this.program?.program_code ?? '', this.entry, this.enrollment_id, isAfterUpdate).subscribe((data: any) => {
      const resdata = data.responsedata as AdditionalAttributeResponse;
      this.responseData = resdata.attributes.map(attr =>
        attr.attribute_text === 'Out Of State' && this.entry === 'participantEnrollment'
          ? { ...attr, is_multiple_allowed: true }
          : attr
      );
      this.transformData(this.responseData)
    });
  }

  transformData(data: AdditionalAttribute[]) {

    // initialize grid data and options
    this.gridData = [];
    this.options = [];
    const seenAttributeTexts = new Set<string>();

    const hasDataMap: Record<string, boolean> = {};
    data?.sort((a, b) => {
      return Number(a.is_read_only) - Number(b.is_read_only);
    });
    data?.forEach((x: AdditionalAttribute) => {
      if (x.data !== null) {
        hasDataMap[x.attribute_text] = true;
      }
    });
    data?.forEach((x: AdditionalAttribute) => {
      if (x.data !== null) {
        const Obj = {
          ...x,
          attribute_id: x.data.id,
          value: x.data.value,
          effective_from_date: x.data.effective_from_date ? this.datePipe.transform(x.data.effective_from_date, 'MM/dd/yyyy') : x.data.effective_from_date,
          effective_to_date: x.data.effective_to_date ? this.datePipe.transform(x.data.effective_to_date, 'MM/dd/yyyy') : x.data.effective_to_date,
          canEdit: x.attribute_text === 'Out Of State' && this.entry === 'participantEnrollment'
            ? this.isSectionEditable && this.canEditEntry
            : this.isSectionEditable
        }
        this.gridData.push(Obj);
      }
      const alreadyHasData = hasDataMap[x.attribute_text] ?? false;
      if (!x.is_read_only && (x.data === null || x.is_multiple_allowed)) {
        if (!seenAttributeTexts.has(x.attribute_text)) {
        if (x.is_multiple_allowed || !alreadyHasData) {
          this.options.push({ ...x, attribute_id: null, disabled: false, value: x});
          seenAttributeTexts.add(x.attribute_text);
          console.log(this.options);
        }
        }
      }
      this.options.sort((a, b) => a.attribute_text.localeCompare(b.attribute_text));

      if (x.lookup) {
        this.lookupData[x.attribute_text] = x.lookup;
      }
    });
    this.actionButtons.edit = this.isSectionEditable;
    this.actionButtons.delete = true;
    this.gridData = [...this.gridData];
    this.options = [...this.options];
  }

  onClose() {
    this.showConfirmationDialog = false;
  }

  getFacilityStays(): void {
    this.leadDetailService.getFacilityStays(
      this.program?.program_code ?? '',
      this.entry,
      this.enrollment_id
    ).subscribe((data: any) => {
      const stays: FacilityStay[] = data.responsedata ?? [];
      this.transformFacilityStayData(stays);
    });
  }

  transformFacilityStayData(stays: FacilityStay[]): void {
    this.facilityStayData = stays.map(stay => ({
      ...stay,
      admitDate: stay.admitDate ? (this.datePipe.transform(stay.admitDate, 'MM/dd/yyyy') ?? '') : '',
      startDateRaw: stay.admitDate,
      dischargeDate: stay.dischargeDate ? this.datePipe.transform(stay.dischargeDate, 'MM/dd/yyyy') : null,
      endDateRaw: stay.dischargeDate,
      modifiedDate: stay.modifiedDate,
      cancelledDisplay: stay.value,
      isActive: stay.isActive,
      isActiveDisplay: stay.isActive ? 'Yes' : 'No',
      stayStatus: stay.stayStatus,
      encounterId: stay.encounterId,
      facilityName: stay.facilityName,
      eventType: stay.eventType,
      lastEventTs: stay.lastEventTs,
      actions: {
        edit: this.isSectionEditable && this.canAddEditFs && stay.stayStatus !== 'CANCELLED',
        delete: this.isSectionEditable && stay.source.toLocaleLowerCase() === 'manual' && this.isPplAdmin && stay.stayStatus !== 'CANCELLED',
        history: true,
      },
    }));
    this.facilityStayData = [...this.facilityStayData].sort((a, b) => {
      const dateA = a.startDateRaw ? new Date(a.startDateRaw).getTime() : 0;
      const dateB = b.startDateRaw ? new Date(b.startDateRaw).getTime() : 0;
      return dateB - dateA;
    });
  }

  validateDateRange(): void {
    const startDate = this.facilityStayForm.get('startDate')?.value;
    const endDate = this.facilityStayForm.get('endDate')?.value;
    if (startDate && endDate && new Date(startDate) > new Date(endDate)) {
      this.fsValidationErrors['dateRange'] = 'Start date cannot be later than end date';
    } else {
      delete this.fsValidationErrors['dateRange'];
    }
  }

  startAddFacilityStay(): void {
    this.fsMode = 'add';
    this.selectedFacilityStay = null;
    this.facilityStayForm.reset({ startDate: null, endDate: null, facilityName: null, eventType: null });
    this.fsValidationErrors = {};
  }

  facilityStayAction(event: GridAction): void {
    const stay = this.facilityStayData.find(s => s.participantFacilityStayAttributesId === event.data?.participantFacilityStayAttributesId) ?? null;
    if (!stay) return;
    this.selectedFacilityStay = stay;

    if (event.action === 'edit') {
      this.fsMode = 'edit';
      this.fsValidationErrors = {};
      this.facilityStayForm.patchValue({
        startDate: stay.startDateRaw ? new Date(stay.startDateRaw) : null,
        endDate: stay.endDateRaw ? new Date(stay.endDateRaw) : null,
        facilityName: stay.facilityName ?? null,
        eventType: stay.eventType ?? null,
      });
    } else if (event.action === 'delete') {
      this.showFsDeleteDialog = true;
    } else if (event.action === 'history') {
      this.leadDetailService.getFacilityStayHistory(this.program?.program_code ?? '', stay.visitGroupId).subscribe((data: any) => {
        this.fsHistoryData = (data?.responsedata ?? []).map((item: any) => ({
          ...item,
          admitDate: item.admitDate ? (this.datePipe.transform(item.admitDate, 'MM/dd/yyyy') ?? item.admitDate) : '',
          dischargeDate: item.dischargeDate ? (this.datePipe.transform(item.dischargeDate, 'MM/dd/yyyy') ?? item.dischargeDate) : '',
          modifiedDate: item.modifiedDate,
          isActiveDisplay: item.isActive ? 'Yes' : 'No',
        }));
        const dialogConfig: DialogConfig = {
          title: 'Facility Stay History',
          showButtons: false,
          showClose: true,
          size: 'large',
          position: 'top',
        };
        this.dialogSvc.openDialog(this.fsHistoryDialogRef, dialogConfig, () => {}, () => {});
      });
    }
  }

  cancelFacilityStayEdit(): void {
    this.fsMode = 'read';
    this.selectedFacilityStay = null;
    this.facilityStayForm.reset({ startDate: null, endDate: null, facilityName: null, eventType: null });
    this.fsValidationErrors = {};
  }

  saveFacilityStay(): void {
    this.fsValidationErrors = {};

    const { startDate, endDate, facilityName, eventType } = this.facilityStayForm.value;
    const payload: any = {
      participantId: this.enrollment_id,
      programCode: this.program?.program_code,
      admitDate: this.datePipe.transform(startDate, 'MM/dd/yyyy'),
      dischargeDate: endDate ? this.datePipe.transform(endDate, 'MM/dd/yyyy') : null,
      facilityName,
    };

    if (this.fsMode === 'edit' && this.selectedFacilityStay) {
      payload.attributeId = this.selectedFacilityStay.participantFacilityStayAttributesId;
    } else {
      payload.attributeId = null;
    }

    const request$ = this.leadDetailService.saveFacilityStay(payload);

    request$.subscribe(() => {
      this.getFacilityStays();
      this.cancelFacilityStayEdit();
    });
  }

  handleConfirmFacilityStayDelete(): void {
    this.showFsDeleteDialog = false;
    if (!this.selectedFacilityStay) return;
    this.leadDetailService.deleteFacilityStay(this.program?.program_code ?? '', this.selectedFacilityStay.participantFacilityStayAttributesId).subscribe(() => {
      this.selectedFacilityStay = null;
      this.getFacilityStays();
    });
  }

  onFsDeleteClose(): void {
    this.showFsDeleteDialog = false;
  }
}

